import React, { memo } from 'react';
import CheckboxTable from 'src/components/common/field/CheckboxTable';
import Stack from '@mui/material/Stack';
import { getField } from 'src/common/helper';

type ContentCheckboxProps = {
  task: any[];
};

const ContentCheckbox: React.FC<ContentCheckboxProps> = (props) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  };

  return (
    <Stack>
      {props.task.map((item: any, index: number) => (
        <CheckboxTable
          value={''}
          key={index}
          label={getField(item, 'text', '-')}
          checked={Boolean(getField(item, 'value', 0))}
          onChange={handleChange}
          sx={{ '& .MuiButtonBase-root': { p: '0px', cursor: 'default'}, '& .MuiTypography-root': { cursor: 'default' } }}
        />
      ))}
    </Stack>
  );
};

export default memo(ContentCheckbox);
